import React from 'react';
import animation from './../../../Images/featured.jpg'
import hook from './../../../Images/hook.png'
import sass from './../../../Images/sass.png'
import './Blog.css'
import Fade from 'react-reveal/Fade';
const Blog = () => {
    return (
        <div>
            <div className="container mt-5" id="blog">
                <div className="row">
                    <h3 className=""><span style={{ borderBottom: '3px solid green' }}>BLOG</span></h3>
                    <div className="col-md-4 mt-5 justify-content-sm-center align-items-sm-center d-flex">
                        <Fade left>
                            <div className="card ms-md-5 f-card" style={{ width: 'auto', boxShadow: '0 0 10px grey' }}>
                                <img src={animation} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <h5 className="text-center">React Animation</h5>
                                    <p className="card-text text-center">Some quick example text to build on react animation</p>
                                    <div className="justify-content-center align-items-center d-flex mt-2">
                                        <a className="btn btn-outline-primary" href="https://rajdevullash111.medium.com/when-we-are-design-frontend-with-react-sometimes-we-need-some-animation-to-look-beautiful-our-4959a47494a4">Read on Medium</a>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>
                    <div className="col-md-4 mt-5 ">
                        <Fade bottom>
                            <div className="card ms-md-5 s-card" style={{ width: 'auto', boxShadow: '0 0 10px grey' }}>
                                <img src={hook} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <h5 className="text-center">How to use React Hook</h5>
                                    <p className="card-text text-center">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                </div>
                            </div>
                        </Fade>
                    </div>
                    <div className="col-md-4 mt-5">
                        <Fade>
                            <div className="card ms-md-5 t-card" style={{ width: 'auto',  boxShadow: '0 0 10px grey' }}>
                                <img src={sass} className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <h5 className="text-center">How to use SASS in React</h5>
                                    <p className="card-text text-center">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;